"use client";

import { useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import WhatsAppButton from "@/components/WhatsAppButton";
import Hero from "@/sections/Hero";
import dynamic from "next/dynamic";
import "../styles/globals.scss";
import LazySection from "../components/IntersectionObserver";

const About = dynamic(() => import("@/sections/About"), { ssr: false });
const Service = dynamic(() => import("@/sections/Service"), { ssr: false });
const Mission = dynamic(() => import("@/sections/Mission"), { ssr: false });
const Client = dynamic(() => import("@/sections/Clients"), { ssr: false });
const Faq = dynamic(() => import("@/sections/Faq"), { ssr: false });
const Contact = dynamic(() => import("@/sections/Contact"), { ssr: false });
const Footer = dynamic(() => import("@/sections/Footer"), { ssr: false });

export default function Page() {
  const [theme, setTheme] = useState<"light" | "dark">("light");

  useEffect(() => {
    const badDarkModeBrowsers = /(SamsungBrowser|UCBrowser|Opera Mini)/i;
    const isBadBrowser = badDarkModeBrowsers.test(navigator.userAgent);

    const applyTheme = (mode: "light" | "dark") => {
      document.documentElement.classList.toggle("dark", mode === "dark");
      setTheme(mode);
    };

    if (isBadBrowser) {
      applyTheme("light");
      return;
    }

    const savedTheme = localStorage.getItem("theme") as "light" | "dark" | null;
    if (savedTheme) {
      applyTheme(savedTheme);
    } else {
      const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      applyTheme(isDark ? "dark" : "light");
    }

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const listener = (e: MediaQueryListEvent) =>
      applyTheme(e.matches ? "dark" : "light");
    mediaQuery.addEventListener("change", listener);

    return () => mediaQuery.removeEventListener("change", listener);
  }, []);

  return (
    <div className="landingPage">
      <Navbar />
      <Hero />
      <About />
      <LazySection id="servicos">
        <Service />
      </LazySection>
      <LazySection id="missao-valores-visao">
        <Mission />
      </LazySection>
      <LazySection id="avaliacoes">
        <Client />
      </LazySection>
      <LazySection id="perguntas">
        <Faq />
      </LazySection>
      <LazySection id="contato">
        <Contact />
      </LazySection>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
